import { render, staticRenderFns } from "./book-issues.vue?vue&type=template&id=841da27e&scoped=true"
import script from "./book-issues.vue?vue&type=script&lang=js"
export * from "./book-issues.vue?vue&type=script&lang=js"
import style0 from "./book-issues.vue?vue&type=style&index=0&id=841da27e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "841da27e",
  null
  
)

export default component.exports